<template>
  <div class="w-full">
      <div class="text-center text-3xl py-6">
          Votre balance actuelle est de ${{ balance }}
          <br><br>
          Veuillez envoyer un virement à interac@livro.ca pour la totalité. Une fois le virement effectué veuillez aviser le bureau afin que nous puissions acuser la réception. Autrement, le compte restera restraint.<br><br>
          Pour rejoindre le bureau composez le <a href="tel:4508581310">450-858-1310</a>
          </div>
  </div>
</template>

<script>
import PhoneFormatter from "../Shared/PhoneFormatter";
import {lang} from "../lang";
import IconClockOutline from "../../icons/outline/IconClockOutline";
export default {
  name: "CannotGrab",
    components: {IconClockOutline, PhoneFormatter},
    props: [
        'app_locale', 'balance'
    ],
    data() {
        return {
            grabbing: false,
        }
    },
    
    methods: {
      
      
        _(k) {
            return lang(k, this.app_locale === 'fr_CA' ? 'fr' : 'en')
        },
    }
}
</script>

<style scoped>

</style>
